module.exports = __webpack_public_path__ + "img/tile-agr1.719399f7.jpg";